export default function alertBanner() {
	const banner = document.querySelector('[data-alert-banner]')
	const close = document.querySelector('[data-alert-banner-close]')

	if (!banner || !close) return

	// Display banner by default
	let showBanner = true

	// Check whether there's a local storage item for this banner
	const bannerKey = window.localStorage.getItem('alert-banner')

	function emitToggleEvent() {
		window.dispatchEvent(new CustomEvent('AlertBannerToggle'))
	}

	function sizeBanner() {
		const wpAdminBar = document.querySelector('#wpadminbar')
		const wpAdminBarHeight = wpAdminBar ? wpAdminBar.getBoundingClientRect().height : 0
		let alertBannerHeight = 0

		if (banner && showBanner) {
			alertBannerHeight = banner.getBoundingClientRect().height
			banner.style.setProperty('--expanded-destination', `${wpAdminBarHeight}px`)
		}
	}

	// If this banner storage item exists, remove it if it has expired
	// and determine whether the banner should be shown or hidden
	if (bannerKey) {
		const now = new Date().getTime()
		const bannerKeyData = JSON.parse(bannerKey)

		// If it's expired, user will see the banner and we'll clear their storage
		if (now > bannerKeyData.expires) {
			window.localStorage.removeItem('alert-banner')
		}

		// Otherwise, they've seen & dismissed this within 24 hours so don't show it again
		else {
			showBanner = false
		}
	}

	if (showBanner) {
		banner.dataset.open = true
		document.body.classList.add('has-alert-banner')
		sizeBanner()
		window.addEventListener('resize', sizeBanner)
		emitToggleEvent()
	}

	close.addEventListener('click', () => {
		delete banner.dataset.open
		const expiresDate = new Date()
		expiresDate.setDate(expiresDate.getDate() + 1)

		window.localStorage.setItem(
			'alert-banner',
			JSON.stringify({
				expires: expiresDate.getTime(),
			})
		)

		document.body.classList.remove('has-alert-banner')
		window.removeEventListener('resize', sizeBanner)
		showBanner = false
		emitToggleEvent()
		sizeBanner()

		setTimeout(() => {
			banner.remove()
		}, 500)
	})
}
